import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

// Create an API using Redux Toolkit Query
const modelMaxChargesAPI = createApi({
    baseQuery: customFetchBase,
    reducerPath: 'modelMaxChargesAPI',
    endpoints: (builder) => ({

        addModelMaxCharges: builder.mutation({
            query: (data) => ({
                url: `/ModelMaxCharges/AddModelMaxCharge`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateModelMaxCharges: builder.mutation({
            query: (data) => ({
                url: `/ModelMaxCharges/UpdateModelMaxCharge`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteModelMaxCharges: builder.mutation({
            query: (data) => ({
                url: `/ModelMaxCharges/DeleteModelMaxCharge?plScopeTypeKey=${data.plScopeTypeKey}&plDepartmentKey=${data.plDepartmentKey}`,
                method: 'DELETE',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllModelMaxCharges: builder.query({
            query: (data) => ({
                url: `/ModelMaxCharges/GetAllModelMaxChargesList?plDepartmentKey=${data}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // deleteModelMaxCharge: builder.mutation({
        //     query: (data) => ({
        //         url: `/ModelMaxCharges/DeleteModelMaxCharge?plScopeTypeKey=${data.plScopeTypeKey}&plDepartmentKey=${data.plDepartmentKey}`,
        //         method: 'DELETE',
        //         body: transformRequest(data),
        //     }),
        //     transformResponse: transformSuccessResponse,
        //     transformErrorResponse: transformErrorResponse,
        // }),


    }),
})

// Destructure the necessary query function for getting all model max charges
export const {
    useLazyGetAllModelMaxChargesQuery,
    useUpdateModelMaxChargesMutation,
    useAddModelMaxChargesMutation,
    useDeleteModelMaxChargesMutation,
    // usedeleteModelMaxChargeMutation
} = modelMaxChargesAPI;

// Export the modelMaxChargesAPI object as default
export default modelMaxChargesAPI;